export function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getUrlParameterFromString(url, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function removeParamFromUrl(parameter, pushState = false) {
    let url = window.location.href;
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0];
        if(pars.join('&') !== "") {
            url += '?' + pars.join('&');
        }

        if(pushState) {
            history.pushState({"filter": url}, "", url);
        } else {
            history.replaceState({"filter": url}, "", url);
        }

        return url;
    } else {
        if(pushState) {
            history.pushState({"filter": url}, "", url);
        } else {
            history.replaceState({"filter": url}, "", url);
        }
        
        return url;
    }
}

export function removeParamFromString(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0];
        if(pars.join('&') !== "") {
            url += '?' + pars.join('&');
        }
        return url;
    } else {
        return url;
    }
}

export function addParamToUrl(param, value, pushState = true) {
    let url = window.location.href;
    var a = document.createElement('a'), regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
    var match, str = [];
    a.href = url;
    param = encodeURIComponent(param);
    // noinspection JSAssignmentUsedAsCondition
    while (match = regex.exec(a.search)) { // noinspection EqualityComparisonWithCoercionJS
        if (param != match[1]) str.push(match[1] + (match[2] ? "=" + match[2] : ""));
    }
    str.push(param + (value ? "=" + encodeURIComponent(value) : ""));
    a.search = str.join("&");

    if (url !== a.href) {
        if(pushState) {
            history.pushState({"filter": a.href}, "", a.href);
        } else {
            history.replaceState({"filter": a.href}, "", a.href);
        }
    }

    return a.href;
}